import { initialState } from './reducer'

// The store's two streams: every dispatched action (actions$, read by
// hooks/use-side-effects.js) and the latest state (getState, read outside
// React by services/analytics.js). They were rxjs Subject and
// BehaviorSubject; only next, subscribe/unsubscribe and getValue were ever
// used, and rxjs cost about 3 KB gzipped of the 250 KB gwmc.js budget
// (client/gwmc/DESIGN.md, bin/check-bundle-size; 17 Oct 2026). Same
// behaviour: a value goes to every subscriber at once, in order.
const subject = (initial, { keepValue = false } = {}) => {
  const listeners = new Set()
  let value = initial
  return {
    next: next => {
      if (keepValue) value = next
      Array.from(listeners).forEach(listener => listener(next))
    },
    subscribe: listener => {
      listeners.add(listener)
      return { unsubscribe: () => listeners.delete(listener) }
    },
    getValue: () => value
  }
}

export const stateSubject = subject(initialState, { keepValue: true })
export const getState = () => stateSubject.getValue()

export const actionsSubject = subject(undefined)
export const actions$ = { subscribe: actionsSubject.subscribe }
